import { ApiException, ContractAnonymousViewModel, ContractsApi, ContractViewModel } from '@ail/contracts-api'
import { createApi } from '@reduxjs/toolkit/query/react'
import { USER_MANAGER } from '../../auth/UserManager'
import { Environment } from '../../environment'
import { getBaseQuery } from './apiQuery'

const client = new ContractsApi({
  baseUrl: Environment.ContractsApiUrl,
  getToken: async () => {
    const user = await USER_MANAGER.getUser()
    return user?.access_token ?? ''
  },
})

export const contractsApi = createApi({
  reducerPath: 'contractsApi',
  baseQuery: getBaseQuery<ApiException>(),
  endpoints: (builder) => ({
    getContract: builder.query<ContractViewModel, string>({
      query: (contractId) => client.getContract(contractId),
    }),
    findContracts: builder.query<ContractAnonymousViewModel[], { chassisNumber?: string, licenseNumber?: string }>({
      query: (model) => client.findContracts(model.chassisNumber, model.licenseNumber),
    }),
    searchContracts: builder.query<ContractViewModel[], { searchTerm?: string, activeOnly?: boolean }>({
      query: (model) => client.searchContracts(model.searchTerm, model.activeOnly),
    }),
  }),
})

export const {
  useLazyGetContractQuery,
  useGetContractQuery,
  useLazyFindContractsQuery,
  useLazySearchContractsQuery,
  useFindContractsQuery,
  useSearchContractsQuery
} = contractsApi
